export default __webpack_public_path__ + "static/bme-facebook-1200x630-178c9436e3e5a10346a2fbe0ce375786.png";